import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onUploadFile = async (file, fileContainerId) => {
  const formData = new FormData();

  // Append the file container ID and the file to the FormData object
  // formData.append('file_container_id', fileContainerId);
  formData.append('file', file);
  const param = fileContainerId ? `?file_container_id=${fileContainerId}` : '';

  // Make the POST request with the FormData object
  try {
    const response = await axios.post(`${apiPaths.fileUploadBase}${param}`, formData);
    return response;
  } catch (error) {
    return error;
  }
};

export { onUploadFile };
